import { useCallback, useContext, useMemo } from "react"
import { AuthContext } from "../context/auth"
import { UserAbilityType } from "../enums"

export default function useUserAbilityType() {
    const { userAbilityType, refreshUserAbilities } = useContext(AuthContext)
    const hasPermissionToUseCredit = useMemo(() => {
        return (
            Array.isArray(userAbilityType) &&
            userAbilityType.includes(UserAbilityType.USE_CREDIT)
        )
    }, [userAbilityType])

    const hasPermissionToUseOrteryDirect = useMemo(() => {
        return (
            Array.isArray(userAbilityType) &&
            userAbilityType.includes(UserAbilityType.USE_ORTERY_DIRECT_3)
        )
    }, [userAbilityType])
    const hasPermissionToConvertToJpg = useMemo(() => {
        return (
            Array.isArray(userAbilityType) &&
            userAbilityType.includes(UserAbilityType.CONVERT_TO_JPG)
        )
    }, [userAbilityType])
    const refreshAbility = useCallback(() => {
        if (refreshUserAbilities) {
            refreshUserAbilities()
        }
    }, [refreshUserAbilities])
    return {
        userAbilityType,
        hasPermissionToUseCredit,
        hasPermissionToUseOrteryDirect,
        hasPermissionToConvertToJpg,
        refreshAbility,
    }
}
